document.addEventListener('DOMContentLoaded', function() {
  // Initial setup
  initBundleItems();
  
  // Re-initialize when the cart is updated
  document.addEventListener('cart:updated', function() {
    setTimeout(initBundleItems, 300);
  });

  // Also listen for cart drawer opening
  document.addEventListener('drawer:open', function() {
    setTimeout(initBundleItems, 300);
  });

  // Add a global click handler for bundle toggles
  document.body.addEventListener('click', function(e) {
    const toggleButton = e.target.closest('.bundle-toggle');
    if (toggleButton) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // Process bundle items data for this specific button if not already processed
      if (toggleButton.hasAttribute('data-bundle-items') && !toggleButton.hasAttribute('data-processed')) {
        processBundleItemsForButton(toggleButton);
        toggleButton.setAttribute('data-processed', 'true');
      }

      const bundleItemsContainer = toggleButton.nextElementSibling;
      if (!bundleItemsContainer || !bundleItemsContainer.classList.contains('bundle-items')) {
        return false;
      }

      const expanded = toggleButton.getAttribute('aria-expanded') === 'true';
      
      if (expanded) {
        toggleButton.setAttribute('aria-expanded', 'false');
        bundleItemsContainer.style.display = 'none';
        const textElement = toggleButton.querySelector('.bundle-toggle-text');
        if (textElement) textElement.textContent = 'הצג פריטים';
        const iconElement = toggleButton.querySelector('.bundle-toggle-icon');
        if (iconElement) iconElement.textContent = '+';
      } else {
        toggleButton.setAttribute('aria-expanded', 'true');
        bundleItemsContainer.style.display = 'block';
        const textElement = toggleButton.querySelector('.bundle-toggle-text');
        if (textElement) textElement.textContent = 'הסתר פריטים';
        const iconElement = toggleButton.querySelector('.bundle-toggle-icon');
        if (iconElement) iconElement.textContent = '-';
      }

      return false;
    }
  }, true);
});

function initBundleItems() {
  // Process all bundle items data
  const toggleButtons = document.querySelectorAll('.bundle-toggle[data-bundle-items]:not([data-processed])');
  toggleButtons.forEach(button => {
    processBundleItemsForButton(button);
    button.setAttribute('data-processed', 'true');
  });
}

// Get the delivery date from the global element or use a fallback
const getDeliveryDateText = () => {
  const globalDateElement = document.getElementById('nextDeliveryDateGlobal');
  if (globalDateElement && globalDateElement.value) {
    return globalDateElement.value;
  }
  
  // Fallback to the non-global element
  const dateElement = document.getElementById('nextDeliveryDate');
  if (dateElement && dateElement.value) {
    return dateElement.value;
  }
  
  // Check for cart delivery date
  const cartDeliveryDate = document.querySelector('.cart-delivery-date');
  if (cartDeliveryDate && cartDeliveryDate.textContent) {
    return cartDeliveryDate.textContent.trim();
  }
  
  // Default fallback text
  return 'זמין בהזמנה הבאה';
};

function processBundleItemsForButton(button) {
  // Find the bundle items container
  const bundleItemsContainer = button.nextElementSibling;
  if (!bundleItemsContainer || !bundleItemsContainer.classList.contains('bundle-items')) return;
  
  const contentContainer = bundleItemsContainer.querySelector('.bundle-items-content');
  if (!contentContainer) return;
  
  try {
    // Get the bundle items JSON string from the data attribute
    let bundleItemsString = button.getAttribute('data-bundle-items');
    let bundleItems;
    
    // Try to parse the JSON
    try {
      bundleItems = JSON.parse(bundleItemsString);
    } catch (e) {
      // If direct parsing fails, try to clean the string
      const decodedString = bundleItemsString
        .replace(/&quot;/g, '"')
        .replace(/\\&quot;/g, '"')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/\\"/g, '"')
        .replace(/\\\\/g, '\\');
      
      try {
        bundleItems = JSON.parse(decodedString);
      } catch (e2) {
        bundleItems = extractBundleItemsFromString(decodedString);
      }
    }
    console.log("bundleItems", bundleItems);

    if (!Array.isArray(bundleItems) || bundleItems.length === 0) {
      contentContainer.innerHTML = '<div class="bundle-item-empty">No bundle items found</div>';
      return;
    }

    // Check if we have day selections data
    let daySelectionsString = button.getAttribute('data-bundle-day-selections');
    let daySelections = null;
    
    if (daySelectionsString) {
      try {
        // Try to parse the day selections JSON
        daySelections = JSON.parse(daySelectionsString);
        console.log("Day selections parsed:", daySelections);
      } catch (e) {
        // If direct parsing fails, try to clean the string
        const decodedString = daySelectionsString
          .replace(/&quot;/g, '"')
          .replace(/\\&quot;/g, '"')
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/\\"/g, '"')
          .replace(/\\\\/g, '\\');
        
        try {
          daySelections = JSON.parse(decodedString);
        } catch (e2) {
          console.error('Failed to parse day selections:', e2);
          daySelections = null;
        }
      }
    }

    // Create a lookup for products by ID for faster access
    const productsLookup = {};
    
    // Process each bundle item to create a lookup
    bundleItems.forEach(item => {
      if (item.productId) {
        productsLookup[item.productId] = item;
      }
      
      if (item.variantId) {
        // Handle both string and array formats for variantId
        if (typeof item.variantId === 'string') {
          productsLookup[item.variantId] = item;
        } else if (Array.isArray(item.variantId)) {
          item.variantId.forEach(id => {
            productsLookup[id] = item;
          });
        }
      }
      
      // Log the out-of-stock status for each item
      console.log(`Bundle item: ${item.title}, isOutOfStock:`, item.isOutOfStock, typeof item.isOutOfStock);
    });

    let bundleItemsHTML = '';
    
    // If we have day selections, display items grouped by day
    if (daySelections && typeof daySelections === 'object' && Object.keys(daySelections).length > 0) {
      // Check the format of day selections
      let isNewFormat = false;
      
      // Check if any day has an array of products (new format)
      for (const day in daySelections) {
        if (Array.isArray(daySelections[day])) {
          isNewFormat = true;
          break;
        }
      }
      
      console.log("Day selections format:", isNewFormat ? "new (array)" : "old (object)");
      
      // Get all products from the bundle items to use for lookup
      const productsLookup = {};
      bundleItems.forEach(item => {
        // Handle different formats of product IDs
        if (item.variantId) {
          // Extract product ID from variant ID (gid://shopify/ProductVariant/12345)
          const variantId = item.variantId.split('/').pop().split('?')[0];
          productsLookup[variantId] = item;
        }
        
        // Also add by the direct product ID if available
        if (item.productId) {
          const productId = item.productId.split('/').pop().split('?')[0];
          productsLookup[productId] = item;
        }
      });
      
      // Also add products from day selections to the lookup if they're in the new format
      Object.values(daySelections).forEach(dayProducts => {
        if (Array.isArray(dayProducts)) {
          dayProducts.forEach(product => {
            if (product && product.variantId) {
              const variantId = product.variantId.split('/').pop().split('?')[0];
              productsLookup[variantId] = product;
            }
            if (product && product.productId) {
              const productId = product.productId.split('/').pop().split('?')[0];
              productsLookup[productId] = product;
            }
          });
        }
      });
      
      // Process each day's selections
      Object.keys(daySelections).forEach((day, dayIndex) => {
        // Use the day number directly from the key since we're already using 1-based indexing in bundle-builder.js
        const dayNumber = parseInt(day);
        const dayProducts = daySelections[day];
        
        // Skip empty days
        if (!dayProducts || (Array.isArray(dayProducts) && dayProducts.length === 0) || 
            (!Array.isArray(dayProducts) && Object.keys(dayProducts).length === 0)) {
          return;
        }
        
        // Calculate day totals
        let dayTotalItems = 0;
        
        // Handle both array format (new) and object format (old)
        if (Array.isArray(dayProducts)) {
          dayProducts.forEach(product => {
            dayTotalItems += product.quantity || 0;
          });
        } else {
          Object.values(dayProducts).forEach(qty => {
            dayTotalItems += qty;
          });
        }
        
        // Create a day header
        bundleItemsHTML += `
          <div class="bundle-day-section">
            <div class="bundle-day-header">
              <span class="bundle-day-title">Day ${dayNumber}</span>
              <span class="bundle-day-total">${dayTotalItems} items</span>
            </div>
            <div class="bundle-day-items">
        `;
        
        // Add each product for this day
        if (Array.isArray(dayProducts)) {
          // New format - array of product objects with complete info
          dayProducts.forEach(product => {
            if (!product || product.quantity <= 0) return;
            
            const imageUrl = (product.image && typeof product.image === 'string') ? product.image.split('?')[0] : '';
            const title = (product.title && typeof product.title === 'string') ? product.title : 'Bundle Item';
            const quantity = (product.quantity && !isNaN(product.quantity)) ? product.quantity : 1;
            
            // Ensure isOutOfStock is correctly evaluated as a boolean
            let isOutOfStock = false;
            if (product.isOutOfStock === true || product.isOutOfStock === "true") {
              isOutOfStock = true;
            }
            
            console.log(`Day ${dayNumber} product: ${title}, isOutOfStock:`, isOutOfStock, typeof product.isOutOfStock, product.isOutOfStock);
            
            bundleItemsHTML += `
              <div class="bundle-item-row">
                <div class="bundle-item-image">
                  <img src="${imageUrl}" alt="${title}" width="30" height="30">
                </div>
                <div class="bundle-item-info">
                  <div class="bundle-item-details">
                    <span class="bundle-item-title">${title}</span>
                    <span class="bundle-item-quantity">× ${quantity}</span>
                  </div>
                  ${isOutOfStock ? `
                    <div class="cart-item__badge cart-item__badge--delivery" 
                      style="display: inline-block; min-width: 90px; max-width: 100%; text-align: center; padding: 3px 8px; margin-top: 8px; background-color: #f4d03f; color: #000000; border-radius: 4px; font-size: 0.7em; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; box-shadow: 0 1px 2px rgba(0,0,0,0.1);"
                    >
                    ${getDeliveryDateText()}
                    </div>
                  ` : ''}
                </div>
              </div>
            `;
          });
        } else {
          // Old format - object with product IDs as keys and quantities as values
          Object.keys(dayProducts).forEach(productId => {
            const quantity = dayProducts[productId];
            if (!quantity || quantity <= 0) return;
            
            // Find product details from our lookup
            let product = productsLookup[productId];
            
            // If product not found in lookup, try to find it in the bundle config
            if (!product) {
              // Try to find the product in the bundle items by matching the ID
              for (const item of bundleItems) {
                if (item.variantId && item.variantId.includes(productId)) {
                  product = item;
                  break;
                }
              }
            }
            
            // If still not found, create a basic product object
            if (!product) {
              product = { 
                title: `Product ${productId}`, 
                image: '', 
                isOutOfStock: false 
              };
            }
            
            const imageUrl = (product.image && typeof product.image === 'string') ? product.image.split('?')[0] : '';
            const title = (product.title && typeof product.title === 'string') ? product.title : 'Bundle Item';
            
            // Ensure isOutOfStock is correctly evaluated as a boolean
            let isOutOfStock = false;
            if (product.isOutOfStock === true || product.isOutOfStock === "true") {
              isOutOfStock = true;
            }
            
            console.log(`Day ${dayNumber} product (old format): ${title}, isOutOfStock:`, isOutOfStock, typeof product.isOutOfStock, product.isOutOfStock);
            
            bundleItemsHTML += `
              <div class="bundle-item-row">
                <div class="bundle-item-image">
                  <img src="${imageUrl}" alt="${title}" width="30" height="30">
                </div>
                <div class="bundle-item-info">
                  <div class="bundle-item-details">
                    <span class="bundle-item-title">${title}</span>
                    <span class="bundle-item-quantity">× ${quantity}</span>
                  </div>
                  ${isOutOfStock ? `
                    <div class="cart-item__badge cart-item__badge--delivery" 
                      style="display: inline-block; min-width: 90px; max-width: 100%; text-align: center; padding: 3px 8px; margin-top: 8px; background-color: #f4d03f; color: #000000; border-radius: 4px; font-size: 0.7em; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; box-shadow: 0 1px 2px rgba(0,0,0,0.1);"
                    >
                    ${getDeliveryDateText()}
                    </div>
                  ` : ''}
                </div>
              </div>
            `;
          });
        }
        
        // Close the day section
        bundleItemsHTML += `
            </div>
          </div>
        `;
      });
    } else {
      // No day selections, display regular bundle items
      bundleItems.forEach(item => {
        const imageUrl = (item.image && typeof item.image === 'string') ? item.image.split('?')[0] : '';
        const title = (item.title && typeof item.title === 'string') ? item.title : 'Bundle Item';
        const quantity = (item.quantity && !isNaN(item.quantity)) ? item.quantity : 1;
        
        // Ensure isOutOfStock is correctly evaluated as a boolean
        let isOutOfStock = false;
        if (item.isOutOfStock === true || item.isOutOfStock === "true") {
          isOutOfStock = true;
        }
        
        console.log(`Regular bundle item: ${title}, isOutOfStock:`, isOutOfStock, typeof item.isOutOfStock, item.isOutOfStock);
        
        bundleItemsHTML += `
          <div class="bundle-item-row">
            <div class="bundle-item-image">
              <img src="${imageUrl}" alt="${title}" width="30" height="30">
            </div>
            <div class="bundle-item-info">
              <div class="bundle-item-details">
                <span class="bundle-item-title">${title}</span>
                <span class="bundle-item-quantity">× ${quantity}</span>
              </div>
              ${isOutOfStock ? `
                <div class="cart-item__badge cart-item__badge--delivery" 
                  style="display: inline-block; min-width: 90px; max-width: 100%; text-align: center; padding: 3px 8px; margin-top: 8px; background-color: #f4d03f; color: #000000; border-radius: 4px; font-size: 0.7em; line-height: 1.4; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; box-shadow: 0 1px 2px rgba(0,0,0,0.1);"
                >
                ${getDeliveryDateText()}
                </div>
              ` : ''}
            </div>
          </div>
        `;
      });
    }
    
    contentContainer.innerHTML = bundleItemsHTML;
  } catch (e) {
    console.error('Error processing bundle items:', e);
    contentContainer.innerHTML = '<div class="bundle-item-error">Could not display bundle items</div>';
  }
}

// Fallback function to extract bundle items from a string when JSON parsing fails
function extractBundleItemsFromString(str) {
  const items = [];
  
  // Look for title patterns
  const titleMatches = str.match(/title\\?":\\?"([^"\\]+)/g) || [];
  const imageMatches = str.match(/image\\?":\\?"([^"\\]+)/g) || [];
  const quantityMatches = str.match(/quantity\\?":\\?"?(\d+)/g) || [];
  
  // Create items based on the number of titles found
  for (let i = 0; i < titleMatches.length; i++) {
    const titleMatch = titleMatches[i].match(/title\\?":\\?"([^"\\]+)/);
    const title = titleMatch ? titleMatch[1] : 'Bundle Item';
    
    const imageMatch = i < imageMatches.length ? imageMatches[i].match(/image\\?":\\?"([^"\\]+)/) : null;
    const image = imageMatch ? imageMatch[1] : '';
    
    const quantityMatch = i < quantityMatches.length ? quantityMatches[i].match(/quantity\\?":\\?"?(\d+)/) : null;
    const quantity = quantityMatch ? parseInt(quantityMatch[1]) : 1;
    
    items.push({
      title: title,
      image: image,
      quantity: quantity
    });
  }
  
  return items;
} 